import { DOCUMENT, KeyValuePipe, NgClass, NgFor, NgIf, isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnInit, Output, PLATFORM_ID, } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppComponent } from 'src/app/app.component';
import { ConsoleLoggerService } from 'src/app/services/console-logger.service';
import Constants from 'src/app/utils/Constants';

@Component({
  selector: 'app-popup-filtri-ricerca',
  templateUrl: './popup-filtri-ricerca.component.html',
  styleUrls: ['./popup-filtri-ricerca.component.scss'],
  standalone: true,
  imports: [NgFor, NgClass, NgIf, FormsModule, KeyValuePipe]
})
export class PopupFiltriRicercaComponent implements OnInit {
  listOfFloors: any = Constants.FILTER_FLOORS;
  listOfConditions: any = Constants.FILTER_CONDITIONS;
  listOfKitchen: any = Constants.TYPE_KITCHEN_FILTER;
  listOfHeating: any = Constants.HEATING;
  listOfContext: any = Constants.CONTEXT;
  listOfGarden: any = Constants.FILTER_GARDEN;
  listOfGarage: any = Constants.FILTER_GARAGE;
  listOfExtra: any = Constants.FILTER_EXTRA;
  listOfAuction: any = Constants.FILTER_IS_AUCTION;

  filtersObj = {
    bathrooms: 0,
    floors: null,
    garden: null,
    garage: null,
    extra: null,
    conditions: null,
    context: null,
    heating: null,
    kitchen: null,
    is_auction: null
  };

  filtersComponentObj = {
    conditions: {
      title: 'Condizioni immobile',
      icon: 'icon-hard-hat',
      value: [],
    },
    context: {
      title: 'Contesto',
      icon: 'icon-home',
      value: [],
    },
    kitchen: {
      title: 'Cucina',
      icon: 'icon-utensils',
      value: [],
    },
    heating: {
      title: 'Riscaldamento',
      icon: 'icon-fire-alt',
      value: [],
    },
    bathrooms: {
      title: 'Bagno',
      icon: 'icon-bath',
      value: 0,
    },
    floors: {
      title: 'Piano',
      icon: 'icon-door-closed',
      value: [],
    },
    garden: {
      title: 'Giardino',
      icon: 'icon-tree',
      value: [],
    },
    garage: {
      title: 'Garage',
      icon: 'icon-car',
      value: [],
    },
    extra: {
      title: 'Extra',
      icon: 'icon-star',
      value: [],
    },
    is_auction: {
      title: 'Asta',
      icon: 'icon-gavel',
      value: [],
    }
  };

  @Input() openMoreFiltersPopup = false;
  @Output() closeMoreFiltersPopupEvt = new EventEmitter();
  @Output() filterSearchChangeEvt = new EventEmitter();
  @Input() changeFilterEvent: EventEmitter<void>;

  constructor(
    public main: AppComponent,
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject(DOCUMENT) private document: Document,
    private console: ConsoleLoggerService,
    private elementRef: ElementRef,
  ) { }

  ngOnInit(): void {
    this.changeFilterEvent.subscribe(() => {
      console.log('evento da ricerca');
      this.cancelFilters();
    });
    this.setActive(this.listOfExtra, this.main?.filtersList?.extra);
    this.setActive(this.listOfGarage, this.main?.filtersList?.garage);
    this.setActive(this.listOfFloors, this.main?.filtersList?.floors);
    this.setActive(this.listOfGarden, this.main?.filtersList?.garden);
    this.setActive(this.listOfConditions, this.main?.filtersList?.conditions);
    this.setActive(this.listOfContext, this.main?.filtersList?.context);
    this.setActive(this.listOfHeating, this.main?.filtersList?.heating);
    this.setActive(this.listOfKitchen, this.main?.filtersList?.kitchen);
    this.setActive(this.listOfAuction, this.main?.filtersList?.is_auction);

    this.filtersComponentObj.conditions.value = this.listOfConditions;
    this.filtersComponentObj.context.value = this.listOfContext;
    this.filtersComponentObj.heating.value = this.listOfHeating;
    this.filtersComponentObj.kitchen.value = this.listOfKitchen;
    this.filtersComponentObj.floors.value = this.listOfFloors;
    this.filtersComponentObj.garden.value = this.listOfGarden;
    this.filtersComponentObj.extra.value = this.listOfExtra;
    this.filtersComponentObj.garage.value = this.listOfGarage;
    this.filtersComponentObj.bathrooms.value = this.main.filtersList?.bathrooms;
    this.filtersComponentObj.is_auction.value = this.listOfAuction;
  }

  setActive(list: any[], filterList: any[]): any {
    list.forEach(element => {
      element.active = false;
      try {
        if (filterList != null && filterList.length > 0 && filterList.includes(element.value)) {
          element.active = true;
        }
      } catch (error) {
        element.active = false;
      }
    });
  }

  closeMoreFiltersPopup(): void {
    this.closeMoreFiltersPopupEvt.emit();
  }

  changeFiltersSearch(e, filterType, i): any {
    this.filtersComponentObj[filterType].value[i].active = !this.filtersComponentObj[filterType].value[i].active;
  }

  changeBathroomsValue(e, filterType): any {
    this.filtersComponentObj[filterType].value = parseInt(e.target.value, 10);
  }

  updateSearch(): any {
    this.filtersObj = {
      bathrooms: null,
      conditions: null,
      context: null,
      heating: null,
      kitchen: null,
      floors: null,
      garden: null,
      extra: null,
      garage: null,
      is_auction: null
    };

    for (const key in this.filtersObj) {
      if (this.filtersComponentObj.hasOwnProperty(key)) {
        try {
          if (this.filtersComponentObj[key]?.value?.length) {
            this.filtersComponentObj[key].value.forEach(element => {
              if (element.active) {
                if (this.filtersObj[key] == null) {
                  this.filtersObj[key] = [];
                }
                this.filtersObj[key].push(element.value);
              }
            });
          } else {
            if (this.filtersComponentObj[key]?.value > 0) {
              this.filtersObj[key] = this.filtersComponentObj[key].value;
            }
          }
        } catch (error) {
          this.console.log(error);
        }
      }
    }
    this.filterSearchChangeEvt.emit(this.filtersObj);
    this.closeMoreFiltersPopupEvt.emit();
  }

  cancelFilters(): any {
    this.filtersComponentObj.conditions.value.forEach(el => el.active = false);
    this.filtersComponentObj.context.value.forEach(el => el.active = false);
    this.filtersComponentObj.heating.value.forEach(el => el.active = false);
    this.filtersComponentObj.kitchen.value.forEach(el => el.active = false);
    this.filtersComponentObj.floors.value.forEach(el => el.active = false);
    this.filtersComponentObj.garden.value.forEach(el => el.active = false);
    this.filtersComponentObj.extra.value.forEach(el => el.active = false);
    this.filtersComponentObj.garage.value.forEach(el => el.active = false);
    this.filtersComponentObj.is_auction.value.forEach(el => el.active = false);

    this.filtersObj = {
      bathrooms: null,
      floors: null,
      conditions: null,
      context: null,
      heating: null,
      kitchen: null,
      garden: null,
      extra: null,
      garage: null,
      is_auction: null
    };

    this.closeMoreFiltersPopupEvt.emit();
  }

  // SE L'UTENTE CLICCA FUORI DAL DROPDOWN VIENE CHIUSO
  @HostListener('window:click', ['$event.target']) onClick(target): void {
    if (isPlatformBrowser(this.platformId)) {
      if (target.classList.contains('bg-modal')) {
        this.closeMoreFiltersPopupEvt.emit();
      }
    }
  }
}
